var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{attrs:{"color":"cyan","border":"left","elevation":"2","colored-border":"","icon":"share"}},[_c('a',{attrs:{"href":_vm.game.link}},[_vm._v("\n\t\t"+_vm._s(_vm.game.link)+"\n\t")])])}
var staticRenderFns = []

export { render, staticRenderFns }